"use client";

import { ctaElementId, ctaHref, trackCtaClick } from "@/lib/analytics";

// Outbound `<a>` that reports a `cta_click` to all analytics sinks and carries the
// `link_id` attribution param. Use inside server components (Footer, Hero) where a
// plain anchor cannot call the client-side tracker directly.
//
// The anchor id defaults to `cta_<linkId>` so GTM can see the click - see
// ctaElementId. Pass an explicit `id` only to keep a legacy name the container
// already matches on.
export function TrackedLink({
  href,
  linkId,
  className,
  children,
  id,
  ...rest
}: {
  href: string;
  linkId: string;
  className?: string;
  children: React.ReactNode;
} & Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, "href" | "onClick">) {
  return (
    <a
      href={ctaHref(href, linkId)}
      id={id ?? ctaElementId(linkId)}
      onClick={() => trackCtaClick(linkId, href)}
      className={className}
      {...rest}
    >
      {children}
    </a>
  );
}
